import { t } from '@hefe/i18n';
import { InventoryTransfer, UserTask } from '@hefe/models';
import { formatDate } from '../../time/time-util';
import { fullUserName } from '../../user/user.utils';

export const useUserTaskData = (userTask: UserTask) => {
  let title = '';
  let description = '';
  switch (userTask.type) {
    case 'INVENTORY_TRANSFER_CONFIRM': {
      const transfer = userTask.data as unknown as InventoryTransfer;
      title = t('user_tasks.inventory.confirm.title');
      description = t('user_tasks.inventory.confirm.description', {
        name: transfer?.inventory?.name,
      });
      break;
    }
    case 'INVENTORY_TRANSFER_RETURN_CONFIRM': {
      const transfer = userTask.data as unknown as InventoryTransfer;
      title = t('user_tasks.inventory.confirm_return.title');
      description = t('user_tasks.inventory.confirm_return.description', {
        name: transfer?.inventory?.name,
        from: transfer?.from_user
          ? fullUserName(transfer?.from_user)
          : t('inventory.pool.title'),
      });
      break;
    }
    case 'INVENTORY_TRANSFER_RETURN':
      {
        const transfer = userTask.data as unknown as InventoryTransfer;
        title = t('user_tasks.inventory.return.title');
        if (transfer?.due_date) {
          description = t(
            'user_tasks.inventory.return.description.with_due_date',
            {
              name: transfer?.inventory?.name,
              date: formatDate(transfer?.due_date),
            }
          );
        } else {
          description = t(
            'user_tasks.inventory.return.description.without_due_date',
            {
              name: transfer?.inventory?.name,
            }
          );
        }
      }
      break;
    default:
      break;
  }

  return { title, description };
};
